/**
 * Vide tracking class
 */
import { firePixelTracking } from 'shared/utils/fireTracking';
import { getTrackingValues } from 'shared/tracking/trackingUtils';
import { isTruthy } from 'shared/utils';
export class VideoTracking {
    constructor(videoConfig) {
        this.replayHasStarted = false;
        this.marks = {
            play: false,
            play25: false,
            play50: false,
            play75: false,
            play100: false,
            replay: false,
            replay25: false,
            replay50: false,
            replay75: false,
            replay100: false,
        };
        this.config = videoConfig;
    }
    resetPlayTracking() {
        this.marks.play = false;
        this.marks.play25 = false;
        this.marks.play50 = false;
        this.marks.play75 = false;
        this.marks.play100 = false;
    }
    resetReplayTracking() {
        this.marks.replay = false;
        this.marks.replay25 = false;
        this.marks.replay50 = false;
        this.marks.replay75 = false;
        this.marks.replay100 = false;
    }
    track(trackKey) {
        this.gatherUrlsAndFirePixels(trackKey);
    }
    startTrackingTime() {
        // stop existing tracking first if any
        if (this.trackingInterval) {
            this.stopTrackingTime();
        }
        this.trackingInterval = window.setInterval(this.onPlayerElapsed.bind(this), 250);
    }
    stopTrackingTime() {
        window.clearInterval(this.trackingInterval);
    }
    startTrackingTimeReplay() {
        this.resetReplayTracking();
        this.replayHasStarted = true; // trigger replay mode
    }
    // for play progress tracking only
    // will reset when video reaches the end in this.end()
    onPlayerElapsed() {
        const elapsed = this.getCurrentTime() / this.duration;
        if (elapsed >= 0) {
            this.fireTrackOncePlayOrReplay('play', 'replay');
        }
        if (elapsed >= 0.25) {
            this.fireTrackOncePlayOrReplay('play25', 'replay25');
        }
        if (elapsed >= 0.5) {
            this.fireTrackOncePlayOrReplay('play50', 'replay50');
        }
        if (elapsed >= 0.75) {
            this.fireTrackOncePlayOrReplay('play75', 'replay75');
        }
        if (elapsed >= 0.95) {
            this.fireTrackOncePlayOrReplay('play100', 'replay100');
        }
        this.onPlayingCallback && this.onPlayingCallback.call(null, this);
    }
    // fire tracking only once while player playing
    fireTrackOnce(trackKey) {
        // no trigger when time point mark is passed
        if (this.marks[trackKey]) {
            return;
        }
        this.gatherUrlsAndFirePixels(trackKey);
        // mark the time point is passed
        this.marks[trackKey] = true;
    }
    // replay tracking triggered when replay is triggered
    fireTrackOncePlayOrReplay(playTrackKey, replayTrackKey) {
        this.replayHasStarted
            ? this.fireTrackOnce(replayTrackKey)
            : this.fireTrackOnce(playTrackKey);
    }
    // gather impression urls and fire those pixels
    gatherUrlsAndFirePixels(trackKey) {
        const urls = getTrackingValues('video', this.config.symbolId)
            .map(t => t[trackKey])
            .filter(isTruthy)
            .map(u => addGustavIdToTrackingUrl(this.config.videoUrl, u));
        urls.forEach(u => {
            firePixelTracking(u);
        });
    }
}
export default VideoTracking;
// https://hlsads.gannett-cdn.com/gustav/[USER_DIRECTORY]/[GUSTAV_ID]/[FORMATS].m3u8
const GUSTAV_ID_REGEX = /^https:\/\/hlsads\.gannett-cdn\.com\/gustav\/[0-9a-f]{32}\/([0-9a-f]{24})\/[a-z0-9,]+\.m3u8/;
/**
 * Adds the GUSTAV ID (if available) to any Traxex tracking URLs.
 */
const addGustavIdToTrackingUrl = (videoUrl, trackingUrl) => {
    const isTraxex = /^https?:\/\/traxex/.test(trackingUrl);
    const gustavMatches = GUSTAV_ID_REGEX.exec(videoUrl);
    if (!isTraxex || gustavMatches === null) {
        return trackingUrl;
    }
    const gustavId = gustavMatches[1];
    const separator = trackingUrl.indexOf('?') === -1 ? '?' : '&';
    return `${trackingUrl}${separator}gustav_id=${gustavId}`;
};
